var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(_vm.verificandoCredenciales === true || _vm.cerrandoSesion === true)?_c('div'):_c('MainContainer'),(_vm.showModalSesionExpirada)?_c('SesionExpiradaModal',{attrs:{"onCloseModal":_vm.onCloseSesionExpiradaModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }